import { useAuth } from '@teetsh/app/src/containers/App/context/AuthContext';
import { UserContext } from './UserContext';
import React from 'react';

function UserProvider(props) {
  const { user } = useAuth();

  return <UserContext.Provider value={user} {...props} />;
}

export { UserProvider };
